import { ColiStatus, IdModel, PaymentStatus, Role, VoyageStatus } from '../models.types';
export type CityPublicModel = {
  name: string;
  country: {
    code: string;
  };
};

export type AgencyPublicDataModel = {
  name: string;
  tel: string;
  address: string;
  zip: string;
  city: CityPublicModel;
  isPartner: boolean;
  isTransportProvider: boolean;
  onlyDelivery: boolean;
  lat?: string;
  lang?: string;
};

export type WarehousePublicDataModel = {
  name: string;
  tel: string;
  address: string;
  zip: string;
  city: CityPublicModel;
  isPartner: boolean;
  isTransportProvider: boolean;
  onlyDelivery: boolean;
};

export type BDCPublicDataModel = {
  restToPay: number;
  createdAt: string;
  price: number;
  tracker: string;
  currency?: string;
};

export type ColiRefund = {
  coli: {
    id: IdModel;
    status: ColiStatus;
    tracker: string;
    measureValue: string;
    priceCurrency?: string;
    price: number;
    selectedCatalogPrice?: {
      name: string;
    } | null;
    selectedEnum?: string | null;
  };
};

export type RefundItem = {
  id: IdModel;
  totalRefund: number;
  createdAt: string;
  currency?: string;
  colis: ColiRefund[];
};
export type VoyagePublicDataModel = {
  startDate: string;
  status: VoyageStatus;
};

export type HistoryPublicModelData = {
  status: ColiStatus;
  agency?: AgencyPublicDataModel | null;
  warehouse?: WarehousePublicDataModel | null;
  voyage?: VoyagePublicDataModel | null;
  createdAt: string;
  description?: string | null;
};

export type coliWithHistoryPublicDataModel = {
  tracker: string;
  measureValue: string;
  price: number;
  status: ColiStatus;
  priceCurrency: string;
  selectedCatalogPrice?: {
    name: string;
  } | null;
  selectedEnum?: string | null;
  history: HistoryPublicModelData[];
};

export type ColiWithHistoryPublicDataModelWithAgency = {
  coli: coliWithHistoryPublicDataModel;
  toAgency: AgencyPublicDataModel;
};

export const availableRoles: Role[] = ['ADMIN', 'SUPPERADMIN', 'AGENT', 'DRIVER', 'PARTNER'];

export type ClientDeliveryRequestStatus =
  | 'PENDING'
  | 'IN_PROGRESS'
  | 'ORGANIZATION_SUGGEST_PRICE'
  | 'ACCEPTED'
  | 'IN_TRANSIT'
  | 'DELIVERED_TO_TRANSPORT'
  | 'AWAITING_CONFIRMATION_BY_CUSTOMER'
  | 'CUSTOMER_CONFIRMED_BY_AGENCY'
  | 'FAILED_DELIVERY'
  | 'CUSTOMER_ABSENCE'
  | 'CUSTOMER_REFUSED_DELIVERY'
  | 'ON_ROAD'
  | 'RETURNED_TO_SENDER'
  | 'PENDING_PAYMENT'
  | 'ON_HOLD'
  | 'REJECTED_BY_CUSTOMER'
  | 'REJECTED_BY_AGENCY'
  | 'SCHEDULING_DELIVERY'
  | 'CANCELLED'
  | 'EXPIRED'
  | 'DELIVERED';

export interface ClientDeliveryRequestHistory {
  status: ClientDeliveryRequestStatus;
  createdAt: string;
}

export type ClientRequestDeliveryTrackingModel = {
  id: string;
  shippingId: string;
  tracker: string;
  name: string;
  phone: string;
  paymentStatus: PaymentStatus;
  address: string;
  status: ClientDeliveryRequestStatus;
  organizationSuggestedPriceNote: string;
  zip: string;
  city: string;
  country: string;
  optInEmail: boolean;
  optInSMS: boolean;
  optInTel: boolean;
  optInEmailDate: string;
  optInSMSDate: string;
  optInTelDate: string;
  history: ClientDeliveryRequestHistory[];
  shipping: {
    id: string;
    organizationId: string;
    tracker: string;
    toAgency: {
      name: string;
      tel: string;
      address: string;
      city: {
        name: string;
        country: {
          code: string;
        };
      };
    };
  };
};

type ClientDeliveryCustomerRating = 'VERY_BAD' | 'BAD' | 'NEUTRAL' | 'GOOD' | 'VERY_GOOD';

export type ClientRequestDeliveryModelWithRatingData = ClientRequestDeliveryTrackingModel & {
  canRate: boolean;
  customerExperienceFeedbackNote?: string;
  customerExperienceFeedbackDate: string;
  customerExperienceFeedbackRatingDriver: ClientDeliveryCustomerRating;
  customerExperienceFeedbackRatingService: ClientDeliveryCustomerRating;
};

export const clientRequestPresentableDefaultStatus: ClientDeliveryRequestStatus[] = [
  'PENDING',
  'REJECTED_BY_AGENCY',
  'ORGANIZATION_SUGGEST_PRICE',
  'REJECTED_BY_CUSTOMER',
  'AWAITING_CONFIRMATION_BY_CUSTOMER',
  'ACCEPTED',
  'SCHEDULING_DELIVERY',
  'ON_ROAD',
  'DELIVERED',
];

export type ClientRequestDeliveryCanConfirmActionModel = {
  id: string;
  shippingId: string;
  tracker: string;
  name: string;
  phone: string;
  address: string;
  status: ClientDeliveryRequestStatus;
  organizationSuggestedPrice: number;
  priceAfterDiscount?: number;
  organizationSuggestedPriceNote: boolean;
  currency: string;
  zip: string;
  city: string;
  country: string;
  optInEmail: boolean;
  optInSMS: boolean;
  optInTel: boolean;
  optInEmailDate: string;
  optInSMSDate: string;
  optInTelDate: string;
  usedPromotionProgram?: {
    code: string;
  };
  history: ClientDeliveryRequestHistory[];
  shipping: {
    id: string;
    organizationId: string;
    tracker: string;
    toAgency: {
      name: string;
      tel: string;
      address: string;
      city: {
        name: string;
        country: {
          code: string;
        };
      };
    };
  };
};
